import React, { useEffect } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Route, Routes, Navigate, useNavigate } from "react-router-dom";

import Login from "./layout/Login";
import PrivateRoute from "./common/PrivateRoute";
import Callback from "./common/Callback";
import App from "./App";
import { setNavigateFunction, redirectTo } from "./utils/history";
import { ACCESS_TOKEN_KEY, handleAuthentication } from './utils/authservice';
import AppIdleTimer from "./utils/AppIdleTimer";
import SamlCallback from "./common/SamlCallback/samlcallback";

const storageListener = (event) => {
  if (event.key === ACCESS_TOKEN_KEY) {
    if (!event.newValue) {
      redirectTo("/login");
    } else if (!event.oldValue && event.newValue && ["/login", "/"].includes(window.location.pathname)) {
      window.location.reload();
    }
  }
}

window.addEventListener('storage', storageListener)

// Wrapper to initialize navigation
const NavigationWrapper = ({ children }) => {
  const navigate = useNavigate();
  
  useEffect(() => {
    setNavigateFunction(navigate);
  }, [navigate]);
  
  return children;
};

const CallbackWrapper = (props) => {
  handleAuthentication(props);
  return <Callback {...props} />;
};

const root = createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <NavigationWrapper>
      <AppIdleTimer>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/saml/callback" element={<SamlCallback />} />
          <Route path="/callback" element={<CallbackWrapper />} />
          <Route path="/admin/*" element={<PrivateRoute><App /></PrivateRoute>} />
          <Route path="/" element={<Navigate to="/admin" replace />} />
        </Routes>
      </AppIdleTimer>
    </NavigationWrapper>
  </BrowserRouter>
);
